import React from "react";

const index = () => {
  return (
    <div className="footer">
      <img
        height="100%"
        src={require("../../assets/images/pcd_logo.png")}
        alt="pcd-logo"
      />
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        Copyright &copy; 2025 All right reserved. Pollution Control Department,
        Thailand.
      </span>
    </div>
  );
};

export default index;
